import keyMirror from 'keymirror'

export default keyMirror({
  GET_PARTNER_API_KEYS_REQUEST: null,
  GET_PARTNER_API_KEYS_SUCCESS: null,
  GET_PARTNER_API_KEYS_FAILED: null,

  GET_PARTNER_API_KEY_DETAIL_REQUEST: null,
  GET_PARTNER_API_KEY_DETAIL_SUCCESS: null,
  GET_PARTNER_API_KEY_DETAIL_FAILED: null,

  UPDATE_FILTER_PARTNER_API_KEY_SUCCESS: null,

  ADD_PARTNER_API_KEY_REQUEST: null,
  ADD_PARTNER_API_KEY_SUCCESS: null,
  ADD_PARTNER_API_KEY_FAILED: null,

  UPDATE_PARTNER_API_KEY_REQUEST: null,
  UPDATE_PARTNER_API_KEY_SUCCESS: null,
  UPDATE_PARTNER_API_KEY_FAILED: null,

  DELETE_PARTNER_API_KEY_REQUEST: null,
  DELETE_PARTNER_API_KEY_SUCCESS: null,
  DELETE_PARTNER_API_KEY_FAILED: null,

  REGENERATE_PARTNER_API_KEY_REQUEST: null,
  REGENERATE_PARTNER_API_KEY_SUCCESS: null,
  REGENERATE_PARTNER_API_KEY_FAILED: null,

  GET_LOGS_PARTNER_API_KEY_REQUEST: null,
  GET_LOGS_PARTNER_API_KEY_SUCCESS: null,
  GET_LOGS_PARTNER_API_KEY_FAILED: null,

  UPDATE_FILTER_LOG_API_KEY_SUCCESS: null,

  ADD_PERIOD_PARTNER_API_KEY_REQUEST: null,
  ADD_PERIOD_PARTNER_API_KEY_SUCCESS: null,
  ADD_PERIOD_PARTNER_API_KEY_FAILED: null,

  UPDATE_PERIOD_PARTNER_API_KEY_REQUEST: null,
  UPDATE_PERIOD_PARTNER_API_KEY_SUCCESS: null,
  UPDATE_PERIOD_PARTNER_API_KEY_FAILED: null,

  DELETE_PERIOD_PARTNER_API_KEY_REQUEST: null,
  DELETE_PERIOD_PARTNER_API_KEY_SUCCESS: null,
  DELETE_PERIOD_PARTNER_API_KEY_FAILED: null
})
